<kendo-dialog title="Log Event" (close)="closeDailog()" [width]="700" [height]="548">
    <div class="dialog-body">
        <div class="loading-container" *ngIf="loadSpinner">
            <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
        </div>

        <div *ngIf="form">
            <form class="k-form k-form-md" [formGroup]="form">
                <div class="content">

                    <div class="layout">

                        <div class="row">
                            <div class="col-sm-12 example-col">
                                <kendo-buttongroup width="100%" [selection]="'single'">

                                    <button kendoButton [toggleable]="true" [disabled]="disableToggle"
                                        (click)="getAction('Outreach')"
                                        [ngClass]="{ 'button-highlight': selectedAction === 'Outreach' }">Outreach</button>
                                    <button kendoButton [toggleable]="true" (click)="getAction('In-reach')"
                                        [disabled]="disableToggle"
                                        [ngClass]="{ 'button-highlight': selectedAction === 'In-reach' }">In-reach</button>

                                </kendo-buttongroup>
                            </div>
                        </div>

                        <div class="contact-details k-my-4">
                            <h4>Related Action</h4>

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Related Action" class="student-document__label"
                                        [for]="relatedAction"> </kendo-label>
                                    <kendo-dropdownlist [data]="relatedActionDropDown" [rounded]="'large'"
                                        [textField]="'description'" formControlName="relatedAction" [valueField]="'id'"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        #relatedAction [size]="'medium'"></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4" *ngIf="showRelatedActionOther">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="Other Description" class="k-w-full">
                                        <kendo-textbox [size]="'medium'" formControlName="relatedActionOther"
                                            rounded="large"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            [fillMode]="'outline'">
                                        </kendo-textbox>
                                    </kendo-floatinglabel>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <!-- Kendo Floating Label for Requested Due By Date -->
                                    <kendo-floatinglabel text="Related Action Date">
                                        <!-- Kendo DatePicker -->
                                        <kendo-datepicker formControlName="relatedActionDate" calendarType="classic"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            rounded="large" placeholder="MM/DD/YYYY" [format]="format"
                                            [max]="currentDate">
                                        </kendo-datepicker>
                                    </kendo-floatinglabel>
                                </div>
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full" *ngIf="showPreviousAttemptsBtn">
                                    <!-- Kendo Floating Label for Extension Days Needed -->
                                    <kendo-floatinglabel text="Attempt(s)">
                                        <kendo-numerictextbox formControlName="previousAttempts" rounded="large"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            [min]="0" format="##" [decimals]="0"></kendo-numerictextbox>

                                    </kendo-floatinglabel>
                                </div>

                            </div>
                        </div>

                        <div class="contact-details k-my-4">
                            <h4>Date/Time</h4>
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="Current Date">
                                        <!-- Kendo DatePicker -->
                                        <kendo-datepicker calendarType="classic" formControlName="dateOccurred"
                                            rounded="large" [max]="todayDate" placeholder="MM/DD/YYYY"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            [format]="format">
                                        </kendo-datepicker>
                                    </kendo-floatinglabel>
                                </div>
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="Time Occurred">
                                        <kendo-timepicker placeholder="" formControlName="timeOccurred"
                                            [rangeValidation]="true"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            [steps]="{ hour: 1, minute: 30}"></kendo-timepicker>
                                    </kendo-floatinglabel>
                                </div>

                            </div>
                        </div>


                        <div class="contact-details k-my-4">
                            <h4>Contact Details</h4>
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-formfield>
                                        <kendo-floatinglabel text="From" class="k-w-full">
                                            <kendo-textbox [size]="'medium'" formControlName="from" rounded="large"
                                                [readonly]="this.action === viewAction || this.action === deleteAction"
                                                [fillMode]="'outline'">
                                            </kendo-textbox>
                                        </kendo-floatinglabel>
                                        <kendo-formerror>{{ form.get('from')?.errors?.validateName?.message
                                            }}</kendo-formerror>
                                    </kendo-formfield>

                                </div>
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-formfield>
                                        <kendo-floatinglabel text="To" class="k-w-full">
                                            <kendo-textbox [size]="'medium'" formControlName="to" rounded="large"
                                                [readonly]="this.action === viewAction || this.action === deleteAction"
                                                [fillMode]="'outline'">
                                            </kendo-textbox>
                                        </kendo-floatinglabel>
                                        <kendo-formerror>{{ form.get('to')?.errors?.validateName?.message
                                            }}</kendo-formerror>
                                    </kendo-formfield>

                                </div>

                            </div>
                        </div>
                        <div class="contact-details k-my-4" *ngIf="isEI">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="EIT Outreach To/From" class="student-document__label"
                                        [for]="eIOutreachToFrom"> </kendo-label>
                                    <kendo-dropdownlist [data]="referenceData.eIOutreachToFrom" [rounded]="'large'"
                                        [textField]="'description'" formControlName="eIOutreachToFrom"
                                        [valueField]="'id'"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        #eIOutreachToFrom [size]="'medium'"></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4" *ngIf="showEIOutreachOther">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="Other" class="k-w-full">
                                        <kendo-textbox [size]="'medium'" formControlName="eIOutreachToFromOther"
                                            rounded="large" [fillMode]="'outline'"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-textbox>
                                    </kendo-floatinglabel>
                                </div>
                            </div>

                        </div>
                        <!-- //Contact Method -->
                        <div class="contact-details k-my-4">


                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Contact Method" class="student-document__label"
                                        [for]="contactMethod"> </kendo-label>
                                    <kendo-dropdownlist [data]="getOutreachMetod" [rounded]="'large'"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        formControlName="contactMethod" [textField]="'description'" [valueField]="'id'"
                                        [size]="'medium'" #contactMethod></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <!-- From - Phone Number -->
                        <div class="contact-details k-my-4" *ngIf="showFromPhone">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="From - Phone Number" class="k-w-full">
                                        <kendo-maskedtextbox [size]="'medium'" type="tel" formControlName="fromPhone"
                                            rounded="large" [fillMode]="'outline'" mask="(000) 000-0000"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-maskedtextbox>
                                    </kendo-floatinglabel>
                                    <kendo-formerror *ngIf="form.get('fromPhone')?.errors">
                                        {{ form.get('fromPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message ??
                                        'Error: Enter a valid 10-digit phone number' }}
                                    </kendo-formerror>
                                </div>
                            </div>

                        </div>

                        <!-- From - Postal Address -->
                        <div class="contact-details k-my-4" *ngIf="showFromPostal">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="From - Postal Address" class="k-w-full">
                                        <kendo-textbox [size]="'medium'" formControlName="fromPostalAddress"
                                            rounded="large" [fillMode]="'outline'"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-textbox>
                                    </kendo-floatinglabel>
                                </div>
                            </div>

                        </div>


                        <!-- From - Email Address -->
                        <div class="contact-details k-my-4" *ngIf="showFromEmail">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="From - Email Address" class="k-w-full">
                                        <kendo-textbox [size]="'medium'" formControlName="fromEmailAddress"
                                            rounded="large" [fillMode]="'outline'"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-textbox>
                                    </kendo-floatinglabel>
                                    <kendo-formerror>{{ form.get('fromEmailAddress')?.errors?.validateEmail?.message
                                        }}</kendo-formerror>
                                </div>
                            </div>

                        </div>
                        <!-- To - Phone Number -->
                        <div class="contact-details k-my-4" *ngIf="showToPhone">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="To - Phone Number " class="k-w-full">
                                        <kendo-maskedtextbox [size]="'medium'" formControlName="toPhone" rounded="large"
                                            [fillMode]="'outline'" mask="(000) 000-0000"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-maskedtextbox>
                                    </kendo-floatinglabel>
                                    <kendo-formerror *ngIf="form.get('toPhone')?.errors">
                                        {{ form.get('toPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message ??
                                        'Error: Enter a valid 10-digit phone number' }}
                                    </kendo-formerror>
                                </div>
                            </div>

                        </div>

                        <!-- To - Postal Address -->
                        <div class="contact-details k-my-4" *ngIf="showToPostal">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-floatinglabel text="To - Postal Address" class="k-w-full">
                                        <kendo-textbox [size]="'medium'" formControlName="toPostalAddress"
                                            rounded="large" [fillMode]="'outline'"
                                            [readonly]="this.action === viewAction || this.action === deleteAction">
                                        </kendo-textbox>
                                    </kendo-floatinglabel>
                                </div>
                            </div>

                        </div>


                        <!-- To - Email Address -->
                        <div class="contact-details k-my-4" *ngIf="showToEmail">

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-formfield>
                                        <kendo-floatinglabel text="To - Email Address" class="k-w-full">
                                            <kendo-textbox [size]="'medium'" formControlName="toEmailAddress"
                                                rounded="large" [fillMode]="'outline'"
                                                [readonly]="this.action === viewAction || this.action === deleteAction">
                                            </kendo-textbox>
                                        </kendo-floatinglabel>
                                        <kendo-formerror>{{ form.get('toEmailAddress')?.errors?.validateEmail?.message
                                            }}</kendo-formerror>
                                    </kendo-formfield>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4" *ngIf="showPreviousAttemptsBtn">


                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Response Method" class="student-document__label"
                                        [for]="responseMethod"> </kendo-label>
                                    <kendo-dropdownlist [data]="referenceData.outreachMethod"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        formControlName="responseMethod" [rounded]="'large'" [textField]="'description'"
                                        #responseMethod [valueField]="'id'" [size]="'medium'"></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4" *ngIf="showPreviousAttemptsBtn">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Engagement Status" class="student-document__label"
                                        [for]="responseMethod">
                                    </kendo-label>
                                    <kendo-dropdownlist [data]="getEngageStatus" [rounded]="'large'"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        formControlName="engagementStatus" [textField]="'description'"
                                        [valueField]="'id'" #responseMethod [size]="'medium'"></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4">
                            <h4>Additional Information</h4>

                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label labelCssClass="hidden-label" text="Select files to upload"
                                        [for]="uploadFiles">
                                        <kendo-fileselect appFileRestrictions class="fileselect-wrapper__select"
                                            formControlName="logEventFile" [showFileList]="true" [multiple]="true"
                                            #uploadFiles>
                                        </kendo-fileselect>
                                    </kendo-label>
                                    <div *ngFor="let file of uploadedDocuments">
                                        {{file.documentName}}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="contact-details k-my-4">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Note" class="student-document__label" [for]="notes">
                                    </kendo-label>
                                    <kendo-formfield class="!k-mt-0" showHints="always">
                                        <kendo-textarea formControlName="notes" placeholder="Type here"
                                            class="student-document__textarea" [rows]="3" resizable="vertical"
                                            [readonly]="this.action === viewAction || this.action === deleteAction"
                                            #notes></kendo-textarea>
                                    </kendo-formfield>
                                </div>
                            </div>

                        </div>

                        <div class="contact-details k-my-4">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Language" class="student-document__label" [for]="language">
                                    </kendo-label>
                                    <kendo-dropdownlist [data]="referenceData.language" formControlName="language"
                                        [rounded]="'large'" [textField]="'description'" [valueField]="'id'"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        [size]="'medium'" #language></kendo-dropdownlist>
                                </div>
                            </div>

                        </div>
                        <div class="contact-details k-my-4">
                            <div class="k-d-flex k-justify-content-stretch">
                                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                    <kendo-label text="Language Support" class="k-w-full"
                                        [for]="languageSupportProvided"> </kendo-label>
                                    <kendo-textbox [size]="'medium'" formControlName="languageSupportProvided"
                                        [readonly]="this.action === viewAction || this.action === deleteAction"
                                        rounded="large" [fillMode]="'outline'" #languageSupportProvided>
                                    </kendo-textbox>

                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- Your page content goes here -->
                </div>
            </form>
        </div>
    </div>

    <kendo-dialog-actions>
        <div class=" k-mt-2 k-text-right margin" *ngIf="form">
            <div class="action-btns   footer">
                <div class="action-btns__right">
                    <button kendoButton size="medium" rounded="large" fillMode="outline" themeColor="error"
                        (click)="closeDailog()">
                        Cancel
                    </button>
                    &nbsp;
                    <button *ngIf="!canDeleted" kendoButton size="medium" (click)="submit()"
                        [disabled]="canSubmited || canTogleSelected || form.invalid || isLogEventSubmitted"
                        rounded="large" fillMode="solid" themeColor="primary">
                        Log Event
                    </button>
                    <button kendoButton size="medium" (click)="submit()" *ngIf="canDeleted" rounded="large"
                        fillMode="outline" themeColor="primary">
                        Delete Log Event
                    </button>
                </div>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>